// Chemin: C:\gestion-copro\src\services\emailAnalysis.service.ts
// Service pour l'analyse IA des emails par SENTINELLE
// Session 38
// Session 126 : Ajout categorie + categorieLabel (taxonomie GED v2)

import { getFunctions, httpsCallable } from 'firebase/functions';
import app from './firebase';

// Initialisation Firebase Functions (région Europe)
const functions = getFunctions(app, 'europe-west1');

// Types
export interface EmailSuggestion {
  typeDocument: string;
  typeDocumentLabel: string;
  categorie: string;
  categorieLabel: string;
  interlocuteurId: string | null;
  interlocuteurNom: string | null;
  affaireId: string | null;
  affaireNom: string | null;
  confidence: 'haute' | 'moyenne' | 'basse';
  explication: string;
}

interface AnalyzeEmailRequest {
  coproprieteId: string;
  emailSubject: string;
  emailFrom: string;
  emailFromEmail: string;
  emailBody: string;
  emailDate: string;
}

interface AnalyzeEmailResponse {
  success: boolean;
  suggestion?: EmailSuggestion;
  error?: string;
}

// Référence à la fonction Cloud
const analyzeEmailFn = httpsCallable<AnalyzeEmailRequest, AnalyzeEmailResponse>(
  functions,
  'analyzeEmail'
);

/**
 * Analyse un email avec SENTINELLE pour obtenir des suggestions de classification
 * 
 * @param coproprieteId - ID de la copropriété
 * @param emailSubject - Objet de l'email
 * @param emailFrom - Nom de l'expéditeur
 * @param emailFromEmail - Email de l'expéditeur
 * @param emailBody - Corps de l'email (texte brut)
 * @param emailDate - Date de l'email
 * @returns Suggestion de classification ou null si échec
 */
export async function analyzeEmail(
  coproprieteId: string,
  emailSubject: string,
  emailFrom: string,
  emailFromEmail: string,
  emailBody: string,
  emailDate: string
): Promise<EmailSuggestion | null> {
  try {
    const result = await analyzeEmailFn({
      coproprieteId,
      emailSubject,
      emailFrom,
      emailFromEmail,
      emailBody,
      emailDate,
    });

    if (result.data.success && result.data.suggestion) {
      return result.data.suggestion;
    }

    console.warn('Analyse email échouée:', result.data.error);
    return null;
  } catch (error) {
    console.error('Erreur analyse email:', error);
    return null;
  }
}
